export default __webpack_public_path__ + "static/media/AcCoolMode.fdca0482.svg";